module.exports = __webpack_public_path__ + "img/license.0abfbae5.png";